import React from "react";

const DAYS = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];

function fmtISO(d) {
    return new Date(d).toISOString().slice(0, 10);
}

export default function ShiftMonthCalendar({ monthStart, shifts, usersMap, isAdmin, onCreate, onEdit }) {
    const today = fmtISO(new Date());
    const year = monthStart.getFullYear();
    const month = monthStart.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    // Calendar starts on Monday
    const offset = (firstDay.getDay() + 6) % 7;
    const totalCells = Math.ceil((offset + lastDay.getDate()) / 7) * 7;

    // Group shifts by date
    const byDate = {};
    for (const s of shifts) {
        byDate[s.date] = byDate[s.date] || [];
        byDate[s.date].push(s);
    }

    return (
        <div className="p-4" data-testid="shift-month-calendar">
            <div className="grid grid-cols-7 gap-1 mb-1">
                {DAYS.map((d) => (
                    <div key={d} className="text-xs font-semibold text-neutral-500 px-2 py-1 uppercase tracking-wider">
                        {d}
                    </div>
                ))}
            </div>
            <div className="grid grid-cols-7 gap-1">
                {Array.from({ length: totalCells }, (_, i) => {
                    const dayNum = i - offset + 1;
                    const inMonth = dayNum >= 1 && dayNum <= lastDay.getDate();
                    const dateObj = new Date(year, month, dayNum);
                    const iso = inMonth ? fmtISO(dateObj) : null;
                    const dayShifts = (iso && byDate[iso]) || [];
                    const isToday = iso === today;
                    return (
                        <div
                            key={i}
                            className={`
                                min-h-[88px] rounded-md p-1.5 border transition-colors
                                ${inMonth ? "bg-white border-neutral-200" : "bg-neutral-50/50 border-transparent"}
                                ${isToday ? "ring-2 ring-neutral-900 ring-inset" : ""}
                                ${isAdmin && inMonth ? "cursor-pointer hover:bg-neutral-50" : ""}
                            `}
                            onClick={() => isAdmin && inMonth && onCreate({ date: iso })}
                            data-testid={iso ? `shift-day-${iso}` : undefined}
                        >
                            {inMonth && (
                                <>
                                    <div className={`text-xs font-semibold ${isToday ? "text-neutral-900" : "text-neutral-600"}`}>
                                        {dayNum}
                                    </div>
                                    <div className="space-y-0.5 mt-1">
                                        {dayShifts.slice(0, 3).map((s) => {
                                            const uName = usersMap[s.user_id]?.name || "?";
                                            return (
                                                <button
                                                    key={s.id}
                                                    onClick={(e) => { e.stopPropagation(); isAdmin && onEdit(s); }}
                                                    className="w-full text-left text-[10px] rounded bg-neutral-900 text-white px-1.5 py-0.5 truncate hover:bg-neutral-700"
                                                    title={`${uName}: ${s.start_time}–${s.end_time}`}
                                                >
                                                    {s.start_time} {uName.split(" ")[0]}
                                                </button>
                                            );
                                        })}
                                        {dayShifts.length > 3 && (
                                            <div className="text-[10px] text-neutral-500 px-1">
                                                + {dayShifts.length - 3} weitere
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
